module.exports = __webpack_public_path__ + "img/man-chat.de6b86c5.png";